
import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
// optional style for arrows & dots
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'
export default {
  name: 'AiDisclosureSummaryContent',
  components: { VueSlickCarousel },
  props: {
    aiSummaryData: {
      type: Array,
      required: true,
    },
    aiSummaryDataError: {
      type: Boolean,
      default: true,
    },

  },
  data() {
    return {
      slickOptions: {
        dots: true,
        arrows: true,
        infinite: false,
        "fade": true,
        speed: 250,
        slidesToShow: 1,
        rows: 1,
        slidesToScroll: 1,
        autoplay: false,
        // "adaptiveHeight": true,
        cssEase: 'ease-in-out',
      },
    }
  },
}
